import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.meeting.room');
import { OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-meeting-room',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.meeting.room/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabMeetingRoomComponent implements OnInit, OnChanges {
    constructor(@Inject( Service) public service: Service) { }

    @Input() meeting_id: string = '';

    public meeting: any = null;
    public members: any[] = [];
    public memberMap: any = {};
    public me: string = '';
    public loaded: boolean = false;
    public editing: boolean = false;
    public form: any = {};

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async ngOnChanges(c: SimpleChanges) {
        if (c['meeting_id'] && !c['meeting_id'].firstChange) await this.load();
    }

    public async load() {
        if (!this.meeting_id) return;
        const r = await wiz.call("get", { id: this.meeting_id });
        if (r.code === 200) {
            this.meeting = r.data.meeting;
            this.me = r.data.me;
            this.members = r.data.members || [];
            this.memberMap = {};
            for (const m of this.members) this.memberMap[m.id] = m;
            this.form = {
                title: this.meeting.title,
                description: this.meeting.description || '',
                scheduled_at: (this.meeting.scheduled_at || '').replace(' ', 'T').slice(0, 16),
                duration: this.meeting.duration,
                room_url: this.meeting.room_url || '',
                agenda: this.meeting.agenda || '',
                notes: this.meeting.notes || '',
            };
        }
        this.loaded = true;
        await this.service.render();
    }

    public memberName(uid: string) {
        return this.memberMap[uid]?.name || this.memberMap[uid]?.email || uid;
    }

    public isHost() {
        return this.meeting && this.meeting.host_id === this.me;
    }

    public myParticipant() {
        return this.meeting?.participants?.find((p: any) => p.user_id === this.me);
    }

    public statusBadge(s: string) {
        const map: any = {
            scheduled: { label: '예정', cls: 'bg-blue-50 text-blue-600' },
            live: { label: '진행중', cls: 'bg-emerald-50 text-emerald-600 animate-pulse' },
            ended: { label: '종료', cls: 'bg-zinc-100 text-zinc-500' },
            cancelled: { label: '취소', cls: 'bg-rose-50 text-rose-600' },
        };
        return map[s] || { label: s, cls: 'bg-zinc-100 text-zinc-500' };
    }

    public partStatusBadge(s: string) {
        const map: any = {
            invited: { label: '초대됨', cls: 'bg-zinc-100 text-zinc-600' },
            accepted: { label: '수락', cls: 'bg-emerald-50 text-emerald-600' },
            declined: { label: '거절', cls: 'bg-rose-50 text-rose-600' },
            tentative: { label: '미정', cls: 'bg-amber-50 text-amber-600' },
            joined: { label: '참여중', cls: 'bg-violet-50 text-violet-600' },
            left: { label: '나감', cls: 'bg-zinc-100 text-zinc-500' },
        };
        return map[s] || { label: s, cls: 'bg-zinc-100 text-zinc-500' };
    }

    public async respond(status: string) {
        const r = await wiz.call("respond", { id: this.meeting_id, status });
        if (r.code === 200) await this.load();
    }

    public async join() {
        const r = await wiz.call("join", { id: this.meeting_id });
        if (r.code === 200) {
            await this.load();
            if (this.meeting.room_url) window.open(this.meeting.room_url, '_blank');
        }
    }

    public async leave() {
        const r = await wiz.call("leave", { id: this.meeting_id });
        if (r.code === 200) await this.load();
    }

    public async end() {
        if (!confirm('회의를 종료하시겠습니까?')) return;
        const r = await wiz.call("end", { id: this.meeting_id });
        if (r.code === 200) await this.load();
    }

    public openEdit() {
        this.editing = true;
    }

    public async saveEdit() {
        const payload: any = {
            id: this.meeting_id,
            title: this.form.title,
            description: this.form.description,
            scheduled_at: this.form.scheduled_at.replace('T', ' ') + ':00',
            duration: this.form.duration,
            room_url: this.form.room_url,
            agenda: this.form.agenda,
            notes: this.form.notes,
        };
        const r = await wiz.call("update", payload);
        if (r.code === 200) {
            this.editing = false;
            await this.load();
        } else {
            this.service.alert.error(r.data?.message || '저장 실패');
        }
    }

    public goBack() {
        this.service.href('/admin/collab/meeting');
    }
}

export default PortalLpsysadminCollabMeetingRoomComponent;